module.exports = __webpack_public_path__ + "img/ico_phmeter59-.95465374.svg";